import { render, staticRenderFns } from "./collection-page.vue?vue&type=template&id=041b17ca"
import script from "./collection-page.vue?vue&type=script&lang=js"
export * from "./collection-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041b17ca')) {
      api.createRecord('041b17ca', component.options)
    } else {
      api.reload('041b17ca', component.options)
    }
    module.hot.accept("./collection-page.vue?vue&type=template&id=041b17ca", function () {
      api.rerender('041b17ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Collections/collection-page.vue"
export default component.exports